import { render } from "./Document.vue?vue&type=template&id=21f7f67a"
const script = {}

import exportComponent from "/var/www/ab-front-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__